/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { communityControllerApproveRequestToJoin } from '../fn/community/community-controller-approve-request-to-join';
import { CommunityControllerApproveRequestToJoin$Params } from '../fn/community/community-controller-approve-request-to-join';
import { communityControllerCreate } from '../fn/community/community-controller-create';
import { CommunityControllerCreate$Params } from '../fn/community/community-controller-create';
import { communityControllerDelete } from '../fn/community/community-controller-delete';
import { CommunityControllerDelete$Params } from '../fn/community/community-controller-delete';
import { communityControllerDenyRequestToJoin } from '../fn/community/community-controller-deny-request-to-join';
import { CommunityControllerDenyRequestToJoin$Params } from '../fn/community/community-controller-deny-request-to-join';
import { communityControllerGetAll } from '../fn/community/community-controller-get-all';
import { CommunityControllerGetAll$Params } from '../fn/community/community-controller-get-all';
import { communityControllerGetJoined } from '../fn/community/community-controller-get-joined';
import { CommunityControllerGetJoined$Params } from '../fn/community/community-controller-get-joined';
import { communityControllerGetMembers } from '../fn/community/community-controller-get-members';
import { CommunityControllerGetMembers$Params } from '../fn/community/community-controller-get-members';
import { communityControllerGetOne } from '../fn/community/community-controller-get-one';
import { CommunityControllerGetOne$Params } from '../fn/community/community-controller-get-one';
import { communityControllerJoin } from '../fn/community/community-controller-join';
import { CommunityControllerJoin$Params } from '../fn/community/community-controller-join';
import { communityControllerLeave } from '../fn/community/community-controller-leave';
import { CommunityControllerLeave$Params } from '../fn/community/community-controller-leave';
import { communityControllerProfilePicture } from '../fn/community/community-controller-profile-picture';
import { CommunityControllerProfilePicture$Params } from '../fn/community/community-controller-profile-picture';
import { communityControllerRequestToJoin } from '../fn/community/community-controller-request-to-join';
import { CommunityControllerRequestToJoin$Params } from '../fn/community/community-controller-request-to-join';
import { communityControllerUpdate } from '../fn/community/community-controller-update';
import { CommunityControllerUpdate$Params } from '../fn/community/community-controller-update';
import { CommunityItem } from '../models/community-item';
import { CommunityItemMinimal } from '../models/community-item-minimal';
import { CommunityMembers } from '../models/community-members';
import { CommunityResponse } from '../models/community-response';
import { MyCommunityResponse } from '../models/my-community-response';

@Injectable({ providedIn: 'root' })
export class CommunityService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `communityControllerGetAll()` */
  static readonly CommunityControllerGetAllPath = '/community';

  /**
   * Restituisce l'elenco delle community.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerGetAll$Response(params: CommunityControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommunityResponse;
}>> {
    return communityControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle community.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerGetAll(params: CommunityControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CommunityResponse;
}> {
    return this.communityControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CommunityResponse;
}>): BaseResponse & {
'data'?: CommunityResponse;
} => r.body)
    );
  }

  /** Path part for operation `communityControllerCreate()` */
  static readonly CommunityControllerCreatePath = '/community';

  /**
   * Crea una community.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerCreate()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  communityControllerCreate$Response(params: CommunityControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommunityItemMinimal;
}>> {
    return communityControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una community.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerCreate$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  communityControllerCreate(params: CommunityControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CommunityItemMinimal;
}> {
    return this.communityControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CommunityItemMinimal;
}>): BaseResponse & {
'data'?: CommunityItemMinimal;
} => r.body)
    );
  }

  /** Path part for operation `communityControllerGetJoined()` */
  static readonly CommunityControllerGetJoinedPath = '/community/my';

  /**
   * Restituisce l'elenco delle mie community (a cui sono iscritto).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerGetJoined()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerGetJoined$Response(params?: CommunityControllerGetJoined$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MyCommunityResponse;
}>> {
    return communityControllerGetJoined(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle mie community (a cui sono iscritto).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerGetJoined$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerGetJoined(params?: CommunityControllerGetJoined$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MyCommunityResponse;
}> {
    return this.communityControllerGetJoined$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MyCommunityResponse;
}>): BaseResponse & {
'data'?: MyCommunityResponse;
} => r.body)
    );
  }

  /** Path part for operation `communityControllerGetOne()` */
  static readonly CommunityControllerGetOnePath = '/community/{id}';

  /**
   * Restituisce una community.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerGetOne$Response(params: CommunityControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommunityItem;
}>> {
    return communityControllerGetOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce una community.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerGetOne(params: CommunityControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CommunityItem;
}> {
    return this.communityControllerGetOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CommunityItem;
}>): BaseResponse & {
'data'?: CommunityItem;
} => r.body)
    );
  }

  /** Path part for operation `communityControllerDelete()` */
  static readonly CommunityControllerDeletePath = '/community/{id}';

  /**
   * Elimina una community.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerDelete$Response(params: CommunityControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommunityItem;
}>> {
    return communityControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina una community.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerDelete(params: CommunityControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CommunityItem;
}> {
    return this.communityControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CommunityItem;
}>): BaseResponse & {
'data'?: CommunityItem;
} => r.body)
    );
  }

  /** Path part for operation `communityControllerUpdate()` */
  static readonly CommunityControllerUpdatePath = '/community/{id}';

  /**
   * Modifica una community.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  communityControllerUpdate$Response(params: CommunityControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommunityItemMinimal;
}>> {
    return communityControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica una community.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  communityControllerUpdate(params: CommunityControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CommunityItemMinimal;
}> {
    return this.communityControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CommunityItemMinimal;
}>): BaseResponse & {
'data'?: CommunityItemMinimal;
} => r.body)
    );
  }

  /** Path part for operation `communityControllerGetMembers()` */
  static readonly CommunityControllerGetMembersPath = '/community/{id}/members';

  /**
   * Restituisce l'elenco degli utenti di una community.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerGetMembers()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerGetMembers$Response(params: CommunityControllerGetMembers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommunityMembers;
}>> {
    return communityControllerGetMembers(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli utenti di una community.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerGetMembers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerGetMembers(params: CommunityControllerGetMembers$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CommunityMembers;
}> {
    return this.communityControllerGetMembers$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CommunityMembers;
}>): BaseResponse & {
'data'?: CommunityMembers;
} => r.body)
    );
  }

  /** Path part for operation `communityControllerJoin()` */
  static readonly CommunityControllerJoinPath = '/community/{id}/join';

  /**
   * Crea la partecipazione alla community.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerJoin()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerJoin$Response(params: CommunityControllerJoin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return communityControllerJoin(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea la partecipazione alla community.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerJoin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerJoin(params: CommunityControllerJoin$Params, context?: HttpContext): Observable<void> {
    return this.communityControllerJoin$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `communityControllerLeave()` */
  static readonly CommunityControllerLeavePath = '/community/{id}/leave';

  /**
   * Abbandona la partecipazione alla community.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerLeave()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerLeave$Response(params: CommunityControllerLeave$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return communityControllerLeave(this.http, this.rootUrl, params, context);
  }

  /**
   * Abbandona la partecipazione alla community.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerLeave$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerLeave(params: CommunityControllerLeave$Params, context?: HttpContext): Observable<void> {
    return this.communityControllerLeave$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `communityControllerRequestToJoin()` */
  static readonly CommunityControllerRequestToJoinPath = '/community/{id}/join/request';

  /**
   * Invia la richiesta di partecipazione alla community.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerRequestToJoin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  communityControllerRequestToJoin$Response(params: CommunityControllerRequestToJoin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return communityControllerRequestToJoin(this.http, this.rootUrl, params, context);
  }

  /**
   * Invia la richiesta di partecipazione alla community.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerRequestToJoin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  communityControllerRequestToJoin(params: CommunityControllerRequestToJoin$Params, context?: HttpContext): Observable<void> {
    return this.communityControllerRequestToJoin$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `communityControllerApproveRequestToJoin()` */
  static readonly CommunityControllerApproveRequestToJoinPath = '/community/{id}/join/request/{request_id}/approve';

  /**
   * Approva la richiesta di partecipazione alla community.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerApproveRequestToJoin()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerApproveRequestToJoin$Response(params: CommunityControllerApproveRequestToJoin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return communityControllerApproveRequestToJoin(this.http, this.rootUrl, params, context);
  }

  /**
   * Approva la richiesta di partecipazione alla community.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerApproveRequestToJoin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerApproveRequestToJoin(params: CommunityControllerApproveRequestToJoin$Params, context?: HttpContext): Observable<void> {
    return this.communityControllerApproveRequestToJoin$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `communityControllerDenyRequestToJoin()` */
  static readonly CommunityControllerDenyRequestToJoinPath = '/community/{id}/join/request/{request_id}/deny';

  /**
   * Respinge la richiesta di partecipazione alla community.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerDenyRequestToJoin()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerDenyRequestToJoin$Response(params: CommunityControllerDenyRequestToJoin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return communityControllerDenyRequestToJoin(this.http, this.rootUrl, params, context);
  }

  /**
   * Respinge la richiesta di partecipazione alla community.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerDenyRequestToJoin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  communityControllerDenyRequestToJoin(params: CommunityControllerDenyRequestToJoin$Params, context?: HttpContext): Observable<void> {
    return this.communityControllerDenyRequestToJoin$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `communityControllerProfilePicture()` */
  static readonly CommunityControllerProfilePicturePath = '/community/{id}/picture';

  /**
   * Foto profilo per la community.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `communityControllerProfilePicture()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  communityControllerProfilePicture$Response(params: CommunityControllerProfilePicture$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommunityItemMinimal;
}>> {
    return communityControllerProfilePicture(this.http, this.rootUrl, params, context);
  }

  /**
   * Foto profilo per la community.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `communityControllerProfilePicture$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  communityControllerProfilePicture(params: CommunityControllerProfilePicture$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CommunityItemMinimal;
}> {
    return this.communityControllerProfilePicture$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CommunityItemMinimal;
}>): BaseResponse & {
'data'?: CommunityItemMinimal;
} => r.body)
    );
  }

}
